import * as React from 'react';
import { Device } from '../misc/api/DeviceLinkApi/Devices';

interface DeviceCardProps {
    device: Device;
    handleClick: () => void;
}

export class DeviceCard extends React.Component<DeviceCardProps> {
    constructor(props: DeviceCardProps) {
        super(props);
    }

    renderSerialNumber = () => {
        if (this.props.device.serial !== null) {
            return (
                <span>
                    <i className="fas fa-tablet-alt"></i> {this.props.device.serial}
                </span>
            );
        } else {
            return (<b className="text-danger">Unconfigured Device</b>);
        }
    }

    renderDeviceSpecifics = () => {
        return null;
    }

    render() {
        var panelClass = this.props.device.serial !== null ? "panel panel-default" : "panel panel-danger";

        return (
            <div className={panelClass} onClick={() => this.props.handleClick()}>
                <div className="panel-body">
                    <div className="col-md-3 text-center">
                        <i className="fas fa-tablet-alt fa-5x text-info"></i>
                        
                    </div>

                    <div className="col-md-9">
                        <div className="label label-primary" style={{ lineHeight: 20 + 'px', float: 'right', position: 'absolute', right: -15 + 'px', top: 0 + 'px' }}>
                            <i className="fab fa-usb text-muted"></i> <span>USB</span>
                        </div>
                        <h3>{this.props.device.name}</h3>
                        {this.renderSerialNumber()}
                    </div>
                </div>
            </div>
        );
    }
}
